<template>
  <p class="text-sm" data-test="TP2">
    <slot />
  </p>
</template>
